import { Card } from "tessa/cards";

export class CdExtensionHelper {
  // Получить список объектов для карточки из секции PkObjectList (секцию PkObjectList предварительно проверять не надо)
  public static GetObjectListFromPkObjectListSection(card: Card) {
    let objectList = [{ ID: null }];
    let index = 0;
    let olSection = card.sections.tryGet('PkObjectList');
    if (olSection) {
      for (let i = 0; i < olSection.rows.length; i++) {
        let row = olSection.rows[i];
        let objectID = row.getField('ObjectID') as guid | null | undefined;
        if (objectID) {
          // @ts-ignore
          objectList[index++] = { ID: objectID };
        }
      }
    }
    if (index > 0)
      return objectList;
    else
      return null;
  }
}